import type { EPGConfigDto } from "$src/core/models/dto";
import getDeviceTimeZone from "$src/core/utils/date/get-device-time-zone";

const isValidTimeZone = (value: string): boolean => {
  try {
    // Throws RangeError for an unknown IANA zone.
    Intl.DateTimeFormat("en-US", { timeZone: value });
    return true;
  } catch {
    return false;
  }
};

/** EPG calendar timezone: the CMS zone when locked and valid, else the device or flavor default. */
const resolveEpgTimeZone = (
  epgConfig: EPGConfigDto | undefined,
  fallbackTimeZone: string,
): string => {
  const timezone = epgConfig?.timezone;

  if (timezone?.mode === "local") {
    return getDeviceTimeZone();
  }

  const value = timezone?.value;

  return value && isValidTimeZone(value) ? value : fallbackTimeZone;
};

export default resolveEpgTimeZone;
